/*
 *  File: subscription.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

 /**
 *
 * @author dlolugu1271
 * @description This model class which describes subscription details
 * and used in other components and services.
 * 
 */
export class Subscription {
    partnerOrderNo: string;
    productId: string;
    firstName: string;
    lastName: string;
    email: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    fullName: string;
    reason: string;
    message: string;
    itemKey: string;

    constructor(subscription) {
        this.partnerOrderNo = subscription.partnerOrderNo;
        this.productId = subscription.productId;
        this.firstName = subscription.firstName;
        this.lastName = subscription.lastName;
        this.email = subscription.email;
        this.address = subscription.address;
        this.city = subscription.city;
        this.state = subscription.state;
        this.zipCode = subscription.zipCode;
        this.fullName = subscription.fullName;
        this.reason = subscription.reason;
        this.message = subscription.message;
        this.itemKey = subscription.itemKey;
    }
}



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/models/subscription.ts